/*
 * @Author: yuanweijiang
 * @Date: 2024-07-22 16:23:11
 * @LastEditors: yuanweijiang
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './user' // 引入用户模块
import mouseFollowToolTip from './mouse-follow-tooltip' // 引入鼠标跟随提示框模块
import oenScreen from './oneScreen'
import guide from './guide'
import homeMap from './home-map' //home页面模块
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user, // 用户模块
        mouseFollowToolTip, // 鼠标跟随提示框模块
        oenScreen,
        homeMap,
        guide
    },
    state: {
        checkTabList: [],
        rightShow: false,
        checkIndex: '',
        tipShow: false,
        setTableShow: false,
        tableName: '米制穿行度',
        echoData: null,
        tipText: '左键选择点位，右键重新选择上一个点，双击左键完成区域的绘制',
        mouseData: {
            top: -100,
            left: 0,
            name: '左键点击'
        },
        fullShow: true,
        exvalue: false
    },

    mutations: {
        setTableName(state, val) {
            state.tableName = val
        },
        setEchoData(state, val) {
            state.echoData = val
        },
        setTableShow(state, val) {
            state.setTableShow = val
        },
        uplateTab(state, item) {
            state.checkTabList.push(item)
            const uniqueArr = Array.from(
                new Set(state.checkTabList.map((item) => JSON.stringify(item))) // 将对象转换为字符串
            ).map((item) => JSON.parse(item))
            state.checkTabList = uniqueArr
        },
        uplateFullShow(state, item) {
            // 判断是否是双屏
            if (!state.oenScreen.showSecondScreen) {
                if (window.isWebview) {
                    // 桌面
                } else {
                    // 网页
                    let datas = {
                        type: 1,
                        fullShow: !!item
                    }
                    window.postMessage(datas, '*')
                }
            }
            state.fullShow = item
        },
        uplateRightShow(state, item) {
            state.rightShow = item
        },
        uplateRightExvalue(state, item) {
            state.exvalue = item
        },

        deleteCheckTab(state, item) {
            state.checkTabList = state.checkTabList.filter((res) => res.name !== item.name)
        },
        updateCheckIndex(state, item) {
            state.checkIndex = item
        },
        updateTipShow(state, item) {
            state.tipShow = item
            // const { flag, status = 'success' } = item
            // state.tipShow = { flag, status }
        },
        uplateTipText(state, item) {
            state.tipText = item
        },
        uplateMouseData(state, item) {
            const { top, left, name } = item
            state.mouseData = {
                top,
                left,
                name
            }
        }
    },
    actions: {}
})

export default store
